import './userTags.less';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { UserTagsContext, UserTagsStore } from './userTagsStore';
import { QuestionCircleOutlined, TagsOutlined } from '@ant-design/icons';
import { Toolbar } from 'controls/react/layout/toolbar';
import { FormEntry } from 'controls/react/form';
import { Section } from 'controls/react/layout/section';
import { AntButton } from 'controls/react/ant/antButton';
import { translator } from 'core/localization/localization';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { AntPopover } from 'controls/react/ant/antPopover';
import { AntAlert } from 'controls/react/ant/antAlert';
import { AntCheckbox } from 'controls/react/ant/antCheckbox';
import { AntSelect } from 'controls/react/ant/antSelect';
import { ApplicationState } from 'framework/applicationState';
import b_ from 'b_';
import { Flex } from 'antd';

const i = translator();

const b = b_.with('user-tags');

export const UserTags = observer(() => {
	const [store] = React.useState(() => new UserTagsStore());

	return (
		<UserTagsContext.Provider value={store}>
			<AntPopover content={<PopoverContent />} trigger={'click'} onOpenChange={store.onOpenChange} open={store.open}>
				<div className={b('icon-wrapper')} title={store.mouseover}>
					<TagsOutlined className={b('icon', { active: ApplicationState.tagsEnabled })} />
				</div>
			</AntPopover>
		</UserTagsContext.Provider>
	);
});

const PopoverContent = observer(() => {
	const context = React.useContext(UserTagsContext);

	return (
		<Section contentPadding={false} width={600}>
			<Toolbar title={i('Tags')}>
				{!context.forced && (
					<AntSwitch
						checkedChildren={i('ON')}
						unCheckedChildren={i('OFF')}
						value={context.active}
						size="small"
						onChange={context.changeActive}
					/>
				)}
				<AntPopover content={<PopupInfoText />} overlayStyle={{ zIndex: 99999999 }} placement="bottom">
					<QuestionCircleOutlined />
				</AntPopover>
			</Toolbar>
			<Section direction={'column'} childrenPadding={true}>
				{context.forcedMessage && <AntAlert message={context.forcedMessage} type="info" />}
				{context.model && (
					<>
						<UserTagsContent />

						<Toolbar appearance="transparent">
							{!context.forced && (
								<AntButton type={'primary'} onClick={context.onOk}>
									{i('Update')}
								</AntButton>
							)}
							<AntButton onClick={context.onCancel}>{context.forced ? i('Close') : i('Cancel')}</AntButton>
						</Toolbar>
					</>
				)}
			</Section>
		</Section>
	);
});

const PopupInfoText = () => {
	return (
		<Section>
			{i('MODAL_INFO_ROW')
				.split('\r\n')
				.map((x: string, index: number) => (
					<span key={index}>{x}</span>
				))}
		</Section>
	);
};

const UserTagsContent = observer(() => {
	const context = React.useContext(UserTagsContext);

	return (
		<Section direction="column" appearance="none" childrenPadding={true}>
			<Flex align="center" justify="flex-end" gap={20}>
				<span>{i('Show subaccount tags')}</span>
				<AntSwitch
					value={context.showSubaccountTags}
					size="small"
					onChange={(value) => (context.showSubaccountTags = value)}
					disabled={context.forced}
				/>
			</Flex>
			<FormEntry>
				<AntSelect
					options={context.tagList}
					disabled={!context.active || context.forced}
					mode="multiple"
					value={context.model.tags}
					onChange={context.onUserTagsChanged}
					filterOption={(input: string, option: { label: string; value: string }) => {
						return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
					}}
				></AntSelect>
			</FormEntry>
			<FormEntry>
				<AntCheckbox
					disabled={!context.active || context.forced}
					value={context.model.showUntagged}
					onChange={context.onChangeUntagged}
				>
					{i('Include Untagged')}
				</AntCheckbox>
			</FormEntry>
		</Section>
	);
});
